import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

function Settings() {
  const [general, setGeneral] = useState({ siteName: 'Owena Admin Dashboard', currency: 'USD', timezone: 'UTC' });
  const [email, setEmail] = useState({ fromName: 'Owena', fromEmail: 'no-reply@owena.com' });
  const [security, setSecurity] = useState({ twoFA: false });

  function handleGeneral(e) { const { name, value } = e.target; setGeneral(prev => ({ ...prev, [name]: value })); }
  function handleEmail(e) { const { name, value } = e.target; setEmail(prev => ({ ...prev, [name]: value })); }
  function handleSecurity(e) { const { name, checked } = e.target; setSecurity(prev => ({ ...prev, [name]: checked })); }
  function saveAll(e) { e.preventDefault(); /* Hook to API here */ }

  return (
    <>
      <Helmet><title>Settings | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Settings</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Settings</p>
            </div>
          </div>

          <form onSubmit={saveAll}>
            <div className="row">
              <div className="col-lg-6">
                <div className="card card-default">
                  <div className="card-header"><h2>General</h2></div>
                  <div className="card-body">
                    <div className="mb-3"><label className="form-label">Site Name</label><input className="form-control" name="siteName" value={general.siteName} onChange={handleGeneral} /></div>
                    <div className="mb-3"><label className="form-label">Currency</label><input className="form-control" name="currency" value={general.currency} onChange={handleGeneral} /></div>
                    <div className="mb-3"><label className="form-label">Timezone</label><input className="form-control" name="timezone" value={general.timezone} onChange={handleGeneral} /></div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card card-default">
                  <div className="card-header"><h2>Email</h2></div>
                  <div className="card-body">
                    <div className="mb-3"><label className="form-label">From Name</label><input className="form-control" name="fromName" value={email.fromName} onChange={handleEmail} /></div>
                    <div className="mb-3"><label className="form-label">From Email</label><input className="form-control" name="fromEmail" value={email.fromEmail} onChange={handleEmail} /></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="card card-default">
                  <div className="card-header"><h2>Security</h2></div>
                  <div className="card-body">
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" id="twoFA" name="twoFA" checked={security.twoFA} onChange={handleSecurity} />
                      <label className="form-check-label" htmlFor="twoFA">Enable Two-Factor Authentication</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <button type="submit" className="btn btn-primary">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Settings;
